import { Box, Typography, Link } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ErrorBoundary } from "lib/@components/busy/error-boundary"
import { ListItemBox } from "lib/@components/ListItemBox"
import { StandardBreadcrumbs } from "lib/@components/standardBreadcrumbs"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { useProject } from "authoring/lib/hooks/use-project"
import { useParams } from "react-router-dom"
import { navigateProject, navigateProjects } from "../utilities/project-navigation"
import {
    Breadcrumbs,
    SelectorTitle,
    SelectorTitleExtras,
    SelectorTitleRight,
    SelectorTitleText,
} from "slot-definitions"

export function ProjectScheduleCrumbs() {
    const {
        target: { code, title },
    } = useBoundContext()
    const { projectId } = useParams()
    const { project } = useProject({ id: projectId })
    const { name } = project || {}

    return (
        <ErrorBoundary>
            <Typography variant="h4" component="div" gutterBottom>
                <SelectorTitle.Slot>
                    <ListItemBox spacing={1}>
                        <SelectorTitleText.Slot>
                            <TruncatedTypography variant="h4">{title}</TruncatedTypography>
                        </SelectorTitleText.Slot>
                        <SelectorTitleExtras.Slot>
                            {code ? (
                                <Typography sx={{ whiteSpace: "nowrap" }} variant="body2" color="text.secondary">
                                    {" "}
                                    #{code}
                                </Typography>
                            ) : null}
                        </SelectorTitleExtras.Slot>
                        <Box flex={1} />
                        <SelectorTitleRight.Slot />
                    </ListItemBox>
                </SelectorTitle.Slot>
            </Typography>
            <Breadcrumbs.Slot>
                <StandardBreadcrumbs
                    sx={{
                        mx: 0,
                        "& li:last-child": {
                            fontWeight: "bold",
                        },
                    }}
                >
                    <Box
                        sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "15vw",
                            whiteSpace: "nowrap",
                            display: "block",
                        }}
                    >
                        <Link sx={{ cursor: "pointer" }} onClick={() => navigateProjects()}>
                            Work Packages
                        </Link>
                    </Box>
                    <Box
                        sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "20vw",
                            whiteSpace: "nowrap",
                            display: "block",
                        }}
                    >
                        <Link sx={{ cursor: "pointer" }} onClick={() => navigateProject(projectId)}>
                            {name}
                        </Link>
                    </Box>
                    <Box
                        sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "15vw",
                            whiteSpace: "nowrap",
                            display: "block",
                        }}
                    >
                        {title}
                    </Box>
                </StandardBreadcrumbs>
            </Breadcrumbs.Slot>
        </ErrorBoundary>
    )
}
